module.exports = __webpack_public_path__ + "img/logo-06.10a6c801.png";